import React from "react";

const getClientCoordinates = event => {
  const pointer =
    event.touches?.[0] ||
    event.changedTouches?.[0] ||
    event.nativeEvent?.touches?.[0] ||
    event.nativeEvent?.changedTouches?.[0] ||
    event;

  return {
    clientX: pointer?.clientX ?? 0,
    clientY: pointer?.clientY ?? 0,
  };
};

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const getCoordinatesFromEvent = event => {
  const svgElement = event.currentTarget;
  const rect = svgElement.getBoundingClientRect();
  const viewBox = svgElement.viewBox?.baseVal;
  const viewBoxWidth = viewBox?.width || 215;
  const viewBoxHeight = viewBox?.height || 584;
  const { clientX, clientY } = getClientCoordinates(event);

  const scale = Math.min(
    rect.width / viewBoxWidth,
    rect.height / viewBoxHeight
  );
  const renderedWidth = viewBoxWidth * scale;
  const renderedHeight = viewBoxHeight * scale;
  const offsetX = rect.left + (rect.width - renderedWidth) / 2;
  const offsetY = rect.top + (rect.height - renderedHeight) / 2;

  const x = clamp((clientX - offsetX) / scale, 0, viewBoxWidth);
  const y = clamp((clientY - offsetY) / scale, 0, viewBoxHeight);

  return { x: parseFloat(x.toFixed(1)), y: parseFloat(y.toFixed(1)) };
};

// pointsToPathString removed - use from pain-assesment.utils.js instead

export const getSvgComponentFromItem = svgItem => {
  if (React.isValidElement(svgItem)) {
    return () => svgItem;
  } else if (typeof svgItem === "function") {
    return svgItem;
  } else if (svgItem && svgItem.component) {
    return svgItem.component;
  }
  return null;
};
